import React from 'react'
import styled from 'styled-components'
import { Price } from 'mojitoswap-sdk'
import { Flex, Text } from 'uikit'
import { multiplyPriceByAmount } from 'utils/prices'
import { useTranslation } from 'react-i18next'
import { useConfig } from 'pages/Predictions/context/ConfigProvider'
import { formatMjt } from '../helpers'

type SummaryType = 'won' | 'lost' | 'entered'

interface SummaryRowProps {
  type: SummaryType
  summary: any
  bnbBusdPrice: Price | number
}

const summaryTypeColors = {
  won: 'success',
  lost: '#F9479C',
  entered: 'text',
}

const summaryTypeSigns = {
  won: '+',
  lost: '-',
  entered: '',
}

const Dot = styled.div<{ status: SummaryType }>`
  width: 6px;
  height: 6px;
  border-radius: 6px;
  margin-right: 8px;
  background: ${({ status, theme }) =>
    status === 'lost' ? summaryTypeColors[status] : theme.colors[summaryTypeColors[status]]};
`

const SummaryRow: React.FC<SummaryRowProps> = ({ type, summary, bnbBusdPrice }) => {
  const { t } = useTranslation()

  const color = summaryTypeColors[type]
  const { rounds, amount } = summary[type]
  const totalRounds = summary.entered.rounds
  const roundsInPercents = ((rounds * 100) / totalRounds).toFixed(2)
  const typeTranslationKey = type.charAt(0).toUpperCase() + type.slice(1)
  const displayAmount = type === 'won' ? summary[type].payout : amount
  const amountInUsd = multiplyPriceByAmount(bnbBusdPrice, displayAmount)
  const { payToken } = useConfig()
  const roundsInPercentsDisplay = !Number.isNaN(parseFloat(roundsInPercents)) ? `${roundsInPercents}%` : '0%'

  return (
    <>
      <Flex alignItems="center">
        <Dot status={type} />
        <Text bold color="text">
          {t(typeTranslationKey)}
        </Text>
      </Flex>

      <Flex mt="6px">
        <Flex flex="2" flexDirection="column">
          <Text bold fontSize="16px" color={color}>
            {rounds} {t('PREDICTION_100').toLocaleLowerCase()}
          </Text>
          <Text fontSize="14px" color="textRemark" mt="4px">
            {type === 'entered' ? t('PREDICTION_101').toLocaleLowerCase() : roundsInPercentsDisplay}
          </Text>
        </Flex>
        <Flex flex="3" flexDirection="column">
          <Text bold fontSize="16px" color={color}>
            {`${summaryTypeSigns[type]}${formatMjt(displayAmount)} ${payToken.symbol}`}
          </Text>
          <Text fontSize="14px" color="textRemark" mt="4px">
            {`~$ ${amountInUsd.toFixed(2)}`}
          </Text>
        </Flex>
      </Flex>
    </>
  )
}

export default SummaryRow
